export default "__VITE_ASSET__T98Blrhx__"